import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { useState, useEffect } from "react";

const { useBreakpoint } = Grid;

export function JourneyCommitment({ commitment_to_excellence = {} }) {
	const [ref, { isVisible }] = useTrackVisibility();
	const screens = useBreakpoint();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);
	return (
		<Container ref={ref}>
			<Row justify="center">
				<Col md={24}>
					<WrapperContent>
						<RATypography
							variant={screens?.xs ? "h4" : "h2"}
							align="center"
							style={{
								padding: "0 28px",
							}}
						>
							{commitment_to_excellence?.title || ""}
						</RATypography>
					</WrapperContent>
					<RATypography
						variant="body3"
						top="20px"
						color="#595959"
						align="center"
						style={{
							padding: "0 40px",
						}}
					>
						{commitment_to_excellence?.sub_title || ""}
					</RATypography>
				</Col>
			</Row>
			<WrapperSection>
				<Row
				// gutter={[40, 20]}
				// style={{ height: "100%", overflowY: "scroll" }}
				>
					<CardContainer
						xxl={12}
						xl={12}
						lg={12}
						md={24}
						sm={24}
						xs={24}
						className={`${visible && "animate__animated animate__zoomIn"}`}
					>
						<CardSectionItem
							name={commitment_to_excellence?.hight_light1?.title}
							description={commitment_to_excellence?.hight_light1?.description}
							image={
								commitment_to_excellence?.hight_light1?.photo || PATH_PUBLIC_IMAGES.journey_commitment_1
							}
						/>
					</CardContainer>
					<CardContainer
						xxl={12}
						xl={12}
						lg={12}
						md={24}
						sm={24}
						xs={24}
						className={`${visible && "animate__animated animate__zoomIn"}`}
					>
						<CardSectionItem
							name={commitment_to_excellence?.hight_light2?.title}
							description={commitment_to_excellence?.hight_light2?.description}
							image={
								commitment_to_excellence?.hight_light2?.photo || PATH_PUBLIC_IMAGES.journey_commitment_2
							}
						/>
					</CardContainer>
					<CardContainer
						xxl={12}
						xl={12}
						lg={12}
						md={24}
						sm={24}
						xs={24}
						className={`${visible && "animate__animated animate__zoomIn"}`}
					>
						<CardSectionItem
							name={commitment_to_excellence?.hight_light3?.title}
							description={commitment_to_excellence?.hight_light3?.description}
							image={
								commitment_to_excellence?.hight_light3?.photo || PATH_PUBLIC_IMAGES.journey_commitment_3
							}
						/>
					</CardContainer>
					<CardContainer
						xxl={12}
						xl={12}
						lg={12}
						md={24}
						sm={24}
						xs={24}
						className={`${visible && "animate__animated animate__zoomIn"}`}
					>
						<CardSectionItem
							name={commitment_to_excellence?.hight_light4?.title}
							description={commitment_to_excellence?.hight_light4?.description}
							image={
								commitment_to_excellence?.hight_light4?.photo || PATH_PUBLIC_IMAGES.journey_commitment_4
							}
						/>
					</CardContainer>
				</Row>
			</WrapperSection>
		</Container>
	);
}

const CardSectionItem = ({ name = "", description = "", image }) => {
	const screens = useBreakpoint();
	return (
		<WrapperItem
			// gutter={[20, 20]}
			style={{ flexWrap: screens.xs ? "wrap" : "nowrap" }}
		>
			<Col style={{ padding: 10 }}>
				<RAImage url={image} width="120px" height="120px" borderRadius="12px 12px 12px 12px" />
			</Col>
			<Col style={{ padding: 10 }}>
				<RATypography variant="h4">{name}</RATypography>
				<RATypography variant="body3" top="4px" color="#595959" style={{ textOverflow: "ellipsis" }}>
					{description}
				</RATypography>
			</Col>
		</WrapperItem>
	);
};

const Container = styled.div`
	width: 100%;
	/* height: 100vh; */
	/* max-height: 90vh; */
	/* padding: 80px 0; */

	display: flex;
	flex-direction: column;
	flex: 1;
	/* overflow: scroll; */
	@media (max-width: 991px) {
		padding: 20px 0;
	}
`;
const WrapperContent = styled.div`
	flex-direction: column;
	align-items: center;
`;
const WrapperSection = styled.div`
	/* padding: 30px 20px; */
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	flex: 1;
	/* overflow: scroll; */
	@media (max-width: 991px) {
		overflow-y: scroll;
	}
`;
const WrapperItem = styled(Row)`
	background: #ffffff;
	/* box-shadow: 0px 4px 40px rgba(76, 85, 94, 0.08); */
	height: 100%;
	border-radius: 12px;
	padding: 10px;
	scroll-snap-align: start;
	height: 100%;
`;

const CardContainer = styled(Col)`
	padding: 15px;

	@media (max-width: 991px) {
		padding: 20px;
	}
`;
